import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center flex-wrap my-1" }
const _hoisted_5 = { class: "d-flex align-items-center position-relative w-250px mb-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 position-absolute ms-6" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "17.0365",
      y: "15.1223",
      width: "8.15546",
      height: "2",
      rx: "1",
      transform: "rotate(45 17.0365 15.1223)",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "d-flex align-items-center position-relative w-250px ms-5 mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 position-absolute ms-6" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "17.0365",
      y: "15.1223",
      width: "8.15546",
      height: "2",
      rx: "1",
      transform: "rotate(45 17.0365 15.1223)",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "d-flex align-items-center position-relative w-250px ms-5 mb-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 position-absolute ms-6" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "17.0365",
      y: "15.1223",
      width: "8.15546",
      height: "2",
      rx: "1",
      transform: "rotate(45 17.0365 15.1223)",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_13 = { class: "d-flex align-items-center ms-5 mb-2" }
const _hoisted_14 = { class: "card-toolbar" }
const _hoisted_15 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<span class=\"svg-icon svg-icon-2\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path opacity=\"0.3\" d=\"M19 15C20.7 15 22 13.7 22 12C22 10.3 20.7 9 19 9C18.9 9 18.9 9 18.8 9C18.9 8.7 19 8.3 19 8C19 6.3 17.7 5 16 5C15.4 5 14.8 5.2 14.3 5.5C13.4 4 11.8 3 10 3C7.2 3 5 5.2 5 8C5 8.3 5 8.7 5.1 9H5C3.3 9 2 10.3 2 12C2 13.7 3.3 15 5 15H19Z\" fill=\"currentColor\"></path><path d=\"M13 17.4V12C13 11.4 12.6 11 12 11C11.4 11 11 11.4 11 12V17.4H13Z\" fill=\"currentColor\"></path><path opacity=\"0.3\" d=\"M8 17.4H16L12.7 20.7C12.3 21.1 11.7 21.1 11.3 20.7L8 17.4Z\" fill=\"currentColor\"></path></svg></span>", 1)
const _hoisted_17 = { class: "card-body py-4 position-relative" }
const _hoisted_18 = {
  key: 0,
  class: "position-absolute w-100 h-100 top-0 start-0 bg-white bg-opacity-50 d-flex align-items-center justify-content-center",
  style: {"z-index":"100"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "table-responsive" }
const _hoisted_22 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_23 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", null, "备注", -1)
const _hoisted_25 = { class: "text-gray-600 fw-semibold" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = {
  key: 0,
  class: "text-dark",
  style: {"white-space":"pre-wrap","word-break":"break-all"}
}
const _hoisted_29 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_30 = { class: "mb-1" }
const _hoisted_31 = { class: "text-muted" }
const _hoisted_32 = { class: "text-end" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.3",
      d: "M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<span class=\"svg-icon svg-icon-3\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z\" fill=\"currentColor\"></path><path opacity=\"0.5\" d=\"M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z\" fill=\"currentColor\"></path><path opacity=\"0.5\" d=\"M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z\" fill=\"currentColor\"></path><rect opacity=\"0.5\" x=\"9\" y=\"10\" width=\"6\" height=\"2\" rx=\"1\" fill=\"currentColor\"></rect><rect opacity=\"0.5\" x=\"9\" y=\"14\" width=\"6\" height=\"2\" rx=\"1\" fill=\"currentColor\"></rect></svg></span>", 1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "d-flex justify-content-end py-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-solid ps-15",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery.user_mobile) = $event)),
              placeholder: _ctx.$t('shipping_record_columns.user_mobile')
            }, null, 8, _hoisted_7), [
              [_vModelText, _ctx.searchQuery.user_mobile]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-solid ps-15",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery.shipping_no) = $event)),
              placeholder: _ctx.$t('shipping_record_columns.shipping_no')
            }, null, 8, _hoisted_10), [
              [_vModelText, _ctx.searchQuery.shipping_no]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-solid ps-15",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery.product_name) = $event)),
              placeholder: "商品名称"
            }, null, 512), [
              [_vModelText, _ctx.searchQuery.product_name]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.dateRange,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dateRange) = $event)),
              type: "daterange",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "value-format": "YYYY-MM-DD",
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary ms-5 mb-2",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)))
          }, _toDisplayString(_ctx.$t('search')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light-primary",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onDownload && _ctx.onDownload(...args)))
          }, [
            _hoisted_16,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('download_excel')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("table", _hoisted_22, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_23, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('shipping_record_columns.id')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('shipping_record_columns.user_nickname')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('shipping_record_columns.user_mobile')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('shipping_record_columns.name')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('shipping_record_columns.mobile')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('shipping_record_columns.area')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('shipping_record_columns.address_detail')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('shipping_record_columns.shipping_provider')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('shipping_record_columns.shipping_no')), 1),
              _hoisted_24,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('shipping_record_columns.products')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('shipping_record_columns.created_at')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('shipping_record_columns.created_by')), 1)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (record) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: record.id
              }, [
                _createElementVNode("td", null, _toDisplayString(record.id), 1),
                _createElementVNode("td", null, _toDisplayString(record.user_nickname), 1),
                _createElementVNode("td", null, _toDisplayString(record.user_mobile), 1),
                _createElementVNode("td", null, _toDisplayString(record.name), 1),
                _createElementVNode("td", null, _toDisplayString(record.mobile), 1),
                _createElementVNode("td", null, _toDisplayString(record.area), 1),
                _createElementVNode("td", null, _toDisplayString(record.address_detail), 1),
                _createElementVNode("td", null, [
                  (_ctx.editingId === record.id)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editForm.shipping_provider) = $event)),
                        class: "form-control form-control-sm form-control-solid",
                        placeholder: _ctx.$t('shipping_record_columns.shipping_provider')
                      }, null, 8, _hoisted_26)), [
                        [_vModelText, _ctx.editForm.shipping_provider]
                      ])
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(record.shipping_provider), 1)
                      ], 64))
                ]),
                _createElementVNode("td", null, [
                  (_ctx.editingId === record.id)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editForm.shipping_no) = $event)),
                        class: "form-control form-control-sm form-control-solid",
                        placeholder: _ctx.$t('shipping_record_columns.shipping_no')
                      }, null, 8, _hoisted_27)), [
                        [_vModelText, _ctx.editForm.shipping_no]
                      ])
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(record.shipping_no), 1)
                      ], 64))
                ]),
                _createElementVNode("td", null, [
                  (record.note)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(record.note), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_29, "-"))
                ]),
                _createElementVNode("td", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.products, (product) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: product.id
                    }, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", null, _toDisplayString(product.name), 1),
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('shipping_record_columns.purchase_price')) + ": ¥" + _toDisplayString(_ctx.formatPrice(product.purchase_price)) + " | " + _toDisplayString(_ctx.$t('shipping_record_columns.quantity')) + ": " + _toDisplayString(product.quantity), 1)
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(record.created_at)), 1),
                _createElementVNode("td", null, _toDisplayString(record.created_by), 1),
                _createElementVNode("td", _hoisted_32, [
                  (_ctx.editingId === record.id)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-light-primary me-2",
                          onClick: ($event: any) => (_ctx.handleSave(record))
                        }, _toDisplayString(_ctx.$t('confirm')), 9, _hoisted_33),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-light",
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                        }, _toDisplayString(_ctx.$t('cancel')), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("button", {
                          class: "btn btn-icon btn-light-primary btn-sm me-2",
                          onClick: ($event: any) => (_ctx.startEdit(record))
                        }, _hoisted_36, 8, _hoisted_34),
                        _createElementVNode("button", {
                          class: "btn btn-icon btn-light-danger btn-sm",
                          onClick: ($event: any) => (_ctx.handleReturn(record))
                        }, _hoisted_39, 8, _hoisted_37)
                      ], 64))
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createVNode(_component_vxe_pager, {
          "current-page": _ctx.page.currentPage,
          "onUpdate:current-page": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.page.currentPage) = $event)),
          "page-size": _ctx.page.pageSize,
          "onUpdate:page-size": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.page.pageSize) = $event)),
          total: _ctx.page.totalResult,
          layouts: [
            'PrevJump',
            'PrevPage',
            'Number',
            'NextPage',
            'NextJump',
            'Sizes',
            'FullJump',
            'Total',
          ],
          onPageChange: _ctx.onPageChange
        }, null, 8, ["current-page", "page-size", "total", "onPageChange"])
      ])
    ])
  ]))
}